import React from "react";
import { useSelector } from "react-redux";
import {
   CartesianGrid,
   Legend,
   Line,
   LineChart,
   ReferenceLine,
   ResponsiveContainer,
   Text,
   Tooltip,
   XAxis,
   YAxis,
} from "recharts";

const NumbersChart = () => {
   const {
      dashboard: { dashboardResponse },
   } = useSelector((state) => state);

   return (
      <ResponsiveContainer width="100%" height={400} aspect={1.1}>
         <LineChart
            height={500}
            data={dashboardResponse?.totalNumberOfMembersGroupedByMonth ?? []}
            margin={{
               top: 25,
               right: 50,
               left: -30,
               bottom: 5,
            }}
         >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="month" />
            <YAxis tickCount={4} tick={[0, 10, 20, 30]} />
            <Text />
            <Line
               type="monotone"
               dataKey="userCount"
               stroke="#8884d8"
               dot={true}
            />
            <ReferenceLine />
            <Tooltip />
            <Legend />
         </LineChart>
      </ResponsiveContainer>
   );
};

export default NumbersChart;
